import * as React from "react"
const Profile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.662}
      d="M27.213 11.492c.601.934.863 2.046.742 3.15l.833-2.585c.694 1.274.684 2.396.106 4.683l.687-1.102a3.662 3.662 0 0 1-.833 2.91l.93-.87c-.836 6.365-5.863 8.356-12.627 8.356m-1.771-.048c-5.696-.317-9.188-2.244-12.06-6.111l1.681.473c-1.126-.67-2.781-2.552-2.278-4.277l2.263 1.878c-.989-1.527-2.197-3.243-1.91-5.35l1.922 1.455c.217-1.07.66-2.08 1.297-2.966"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.662}
      d="m22.665 18.511.967 1.159.533-1.297-1.5.138Zm.934 2.522c.384.64.574.694 1.365.583a6.218 6.218 0 0 0-1.043.832c-.526.63-.507 1.676-1.162 2.171a.788.788 0 0 1-.585.128.744.744 0 0 1-.512-.308c-.362-.6-.015-1.408-.119-2.102-.06-.401-.29-1.183-.29-1.183.9.625 1.72.568 2.346-.121ZM18.057 17.736c.33 0 .597-.4.597-.896 0-.494-.267-.895-.597-.895-.33 0-.597.4-.597.895s.267.896.597.896ZM25.555 17.744c.264 0 .478-.348.478-.777 0-.428-.214-.776-.478-.776s-.478.348-.478.776c0 .429.214.777.478.777ZM6.72 6.985a7.077 7.077 0 0 1 1.246-4.036c1.23.277 2.4.774 3.451 1.47m1.975 1.785c.387.466.733.964 1.036 1.49m7.232.37a9.09 9.09 0 0 1 .793-2.073m1.101-1.557a8.757 8.757 0 0 1 1.453-1.315c.48.46.867 1.007 1.142 1.612M13.79 6.682c3.863-.777 5.392-.534 7.956.6"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.662}
      d="m7.244 9.144 2.39-3.582c1.603-2.406 12.61-3.155 16.053.286l2.985 2.987-1.194 1.193-2.986-2.985c-2.406-2.406-11.49-2.056-13.067.31l-2.39 3.582-1.79-1.79Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.662}
      d="M12.02 6.81a3.902 3.902 0 0 1 .525 4.741 3.494 3.494 0 0 1-4.327 1.466 3.797 3.797 0 0 1-2.213-4.17 3.64 3.64 0 0 1 3.463-3.092M25.04 5.24c1.156-.812 2.606-.438 3.42.881a4.112 4.112 0 0 1-.152 4.416 2.294 2.294 0 0 1-3.468.502 3.965 3.965 0 0 1-.933-4.261"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.662}
      d="m7.825 12.875-.23 1.323.948.295.707-1.213m-1.193 1.136c-.057.435-.06.876-.006 1.311.171.713 1.022 1.219 1.008 1.95-.032 1.689-2.336 2.726-2.496 4.406-.232 2.44 2.63 4.203 2.353 6.967M17.576 20.99a4.479 4.479 0 1 0 0-8.958 4.479 4.479 0 0 0 0 8.957ZM17.141 21.043l-.136 1.338m-5.489 6.67a.587.587 0 0 0-.208-.677.806.806 0 0 0-1 .112l-.496.564m6.936-5.037-.28 1.435m-.813 1.267-1.569.752m-1.26.215-1.755.953m6.057-6.707a.888.888 0 0 0-.934.686l-.089 1.004a.784.784 0 0 0 .478.803.961.961 0 0 0 1.01-.716l.123-.837a.898.898 0 0 0-.588-.94ZM15.77 25.46l-.472.743a.685.685 0 0 0 .05.815.84.84 0 0 0 1.069-.15l.432-.6a.785.785 0 0 0-.086-.97.775.775 0 0 0-.993.162Zm-2.058 1.4-.867.153c-.269.047-.584.313-.57.584a.84.84 0 0 0 .831.69l.735-.085a.784.784 0 0 0 .66-.715.774.774 0 0 0-.789-.626Z"
    />
  </svg>
)
export default Profile